/**
 * Onboarding Context Types
 */

export enum OnboardingAchievement {
  BuildLicense = 'build-license',
}

export interface IUnlockedAchievement {
  id: OnboardingAchievement;
  acknowledged: boolean;
}

export type SerializedAchievements = OnboardingAchievement[];

export type OnboardingAchievementHandler<R = void> = (achievement: OnboardingAchievement) => R;

export interface IOnboardingContext {
  achievements: IUnlockedAchievement[];
  acknowledgeAchievement: OnboardingAchievementHandler;
  isNewAchievement: OnboardingAchievementHandler<boolean>;
  unlockAchievement: OnboardingAchievementHandler;
  hasNewAchievement(): boolean;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/onboarding/types.ts